<smart-card [backButton]="true" [offset]="2" class="crud-details-wrapper">
  <h2 [innerText]="title"></h2>
  @if (!isLoading && data) {
  <app-detail-fields-base
    [allowFileUpload]="allowFileUpload"
    [detailFields]="detailFields"
    [data]="data"
  ></app-detail-fields-base>
  }
  <ng-template appPlaceholder></ng-template>
  @if (isDevMode) {
  <details>
    <pre>{{ data | json }}</pre>
  </details>
  }
</smart-card>
<spinner-overlay [show]="isLoading"></spinner-overlay>
